import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-construction-site',
  templateUrl: './construction-site.component.html',
  styleUrls: ['./construction-site.component.less']
})
export class ConstructionSiteComponent implements OnInit {
  subjects: any[] = [];
  currentProject: any;
  projectSubscription: Subscription;
  remarkEnabled = false;
  dueRealisedNumber: number = 0;
  dueEchueNumber: number = 0;
  worksite: any = null;
  owner: any = null;
  status = 'loading';

  constructor(
    private requestService: RequestService,
    private requestV2Service: RequestV2Service,
    private globalDataService: GlobalDataService
  ) {}

  ngOnInit() {
    this.projectSubscription = this.globalDataService
      .getCurrentProject()
      .subscribe(async (project: any) => {
        if (!project || this.currentProject) {
          return;
        }

        this.currentProject = project;

        this.currentProject._related._project_user_roles.forEach((userR: any) => {
          if (this.worksite !== null && this.owner !== null) {
            return;
          }

          if (userR.project_role.name === 'worksite') {
            this.worksite = userR.user;
          }
          if (userR.project_role.name === 'owner') {
            this.owner = userR.user;
          }
        });

        this.status = 'idle';

        this.fetchAndFormatSubjects();
      });
  }

  async fetchAndFormatSubjects() {
    const subjectResults = await this.requestV2Service
      .getProjectSubjects(this.currentProject.id, true);
    const apiSubjects = subjectResults.items;

    this.subjects = apiSubjects;

    this.subjects.forEach((subject: any) => {
      if (subject.dates.resolution) {
        this.dueRealisedNumber += 1;
      }

      const date = subject.dates.resolution || subject.dates.due || subject.dates.creation;

      if (new Date(date).getTime() < new Date().getTime()) {
        this.dueEchueNumber += 1;
      }

      if (subject._related.users[0] !== null) {
        subject._related.users.forEach((concernedUser: any) => {
          this.currentProject._related._project_user_roles.forEach((userR: any) => {
            if (userR.user.id === concernedUser.id) {
              concernedUser.role = userR.project_role.name;
            }
          });
        });
      }

    });
  }

  onUpdateListSubjects(subject:boolean) {
    if (subject) {
      this.fetchAndFormatSubjects();
    }
    this.remarkEnabled = false;
  }

  ngOnDestroy(): void {
    this.projectSubscription.unsubscribe();
  }
}
